import Combobox from "@ls/react-combobox-grid";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectAnalyticValuesSelectionOptions,
  selectFetchingAnalyticValues,
} from "state/analytics/selectors";
import { calcTypeOptions } from "state/Constants/CalcType";
import ScaleType, { scaleTypeOptions } from "state/Constants/ScaleType";
import { Cell, Grid } from "styled-css-grid";

const AnalyticsSelectorComplication = ({ setDefinition, definition }) => {
  const analyticOptions = useSelector(selectAnalyticValuesSelectionOptions);
  const fetchingAnalyticValues = useSelector(selectFetchingAnalyticValues);

  const [setAnalytic, setScaleType, setCalcType] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setAnalytic(value)),
      (value) => setDefinition(definition.setScaleType(value)),
      (value) => setDefinition(definition.setCalcType(value)),
    ];
  }, [definition, setDefinition]);

  // Disable calc type when scale type is RATIO
  const isCalcTypeDisabled = definition.scaleType === ScaleType.Ratio;

  return (
    <Grid columns={12} gap="4px">
      <Cell width={6}>
        <Combobox
          options={analyticOptions}
          onChange={setAnalytic}
          isLoading={fetchingAnalyticValues}
          value={definition.analytic}
          label="Analytic:"
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          options={scaleTypeOptions}
          onChange={setScaleType}
          value={definition.scaleType}
          label="Type:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={120}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          options={calcTypeOptions}
          onChange={setCalcType}
          value={definition.calcType}
          label="Calc:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={120}
          disabled={isCalcTypeDisabled}
        />
      </Cell>
    </Grid>
  );
};

AnalyticsSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default AnalyticsSelectorComplication;
